import { Link } from "react-scroll";

function Header() {
  return (
    <header className="bg-landingPage relative">
      <div className="mx-auto flex items-center justify-between px-4 py-2 relative">
        {/* اللوغو */}
        <div className="flex-shrink-0">
          <Link to="home" className="cursor-pointer">
            <img
              src="/images/bunat.png"
              alt="Bunat Logo"
              className="h-12 md:h-16 w-auto"
              decoding="async"
              fetchpriority="high"
            />
          </Link>
        </div>

        {/* الناف بار */}
        <nav
          className="hidden lg:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2
                     bg-light text-navtext font-medium rounded-full shadow-xl px-14 py-3 max-w-2xl w-full justify-center"
          aria-label="التنقل الرئيسي"
        >
          <ul className="flex justify-around items-center text-lg text-dark w-full">
            <li>
              <Link
                to="home"
                smooth={true}
                spy={true}
                duration={500}
                activeClass="text-primary"
                className="cursor-pointer font-medium inline-block transition-transform transform hover:scale-110 hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:rounded-full ring-offset-white"
              >
                الصفحة الرئيسية
              </Link>
            </li>
            <li>
              <Link
                to="download"
                smooth={true}
                spy={true}
                duration={500}
                activeClass="text-primary"
                className="cursor-pointer font-medium inline-block transition-transform transform hover:scale-110 hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:rounded-full ring-offset-white"
              >
                حمل التطبيق
              </Link>
            </li>
            <li>
              <Link
                to="achievements-volunteer"
                smooth={true}
                spy={true}
                duration={500}
                activeClass="text-primary"
                className="cursor-pointer font-medium inline-block transition-transform transform hover:scale-110 hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:rounded-full ring-offset-white"
              >
                إنجازات بناة
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth={true}
                spy={true}
                duration={500}
                activeClass="text-primary"
                className="cursor-pointer font-medium inline-block transition-transform transform hover:scale-110 hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:rounded-full ring-offset-white"
              >
                تواصل معنا
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
